import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import companyToken from "Utils/companyToken";
import { prepareHeadersWithCSRFToken } from "Utils/fetchWithCSRFToken";

import { appendAuthParams } from "Common/TokenAuth/Utils";

import { MedicalPlanMapping } from "./medicalPlanMappings.types";

type MedicalPlanMappingsArgs = {
  companyPolicyID: string;
};

type MedicalPlanMappingsResponse = {
  medicalPlanMappings: MedicalPlanMapping[];
};

export const medicalPlanMappingsApi = createApi({
  reducerPath: "medicalPlanMappings",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/v2/",
    prepareHeaders: prepareHeadersWithCSRFToken,
  }),
  endpoints: (builder) => ({
    getMedicalPlanMappings: builder.query<MedicalPlanMappingsResponse, MedicalPlanMappingsArgs>({
      query: ({ companyPolicyID }) => {
        // "current" is resolved from the company, which the backend cannot pick for an
        // account that administers more than one, so the identifier travels with it.
        const companyIDToken = companyToken();
        const params = new URLSearchParams(companyIDToken ? { company_id_token: companyIDToken } : {}).toString();
        return appendAuthParams(`/company_policies/${companyPolicyID}/medical_plan_mappings${params ? `?${params}` : ""}`);
      },
      providesTags: ["MedicalPlanMappings"],
    }),
  }),
  tagTypes: ["MedicalPlanMappings"],
});

export const { useGetMedicalPlanMappingsQuery } = medicalPlanMappingsApi;
